import { useEffect, useState } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import CustomModal from '@/components/shared/CustomModal/CustomModal'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'
import { ModalBody, ModalFooter, ModalHeader } from '../shared/CustomModal'


export const AssignTracts = ({
    showAdd,
    showHideAdd,
    showCreateTract,
    runsheetId,
    isRunsheetTab,
    tractId,
    tabId,
}) => {
    
    const runsheetTabs = useWireValue(store.runsheetTabs)
    const [selectedTractId, setSelectedTractId] = useState(tractId)
    const selectedTab = runsheetTabs?.find(rt => rt.id === tabId) || {}
    
    const tracts = useWireValue(store.tracts)
    
    const assignTract = async () => {
        if (isRunsheetTab) {
            await actions.updateRunsheetTab(tabId, { tractId: selectedTractId })
            
            toast.success(`Assigned Tract "${tracts.find(t => t.id === selectedTractId).name.trim()}" to Tab`)
        } else {
            await actions.assignTractsToRunsheet(runsheetId, selectedTractId)
            
            toast.success(`Assigned Tract "${tracts.find(t => t.id === selectedTractId).name.trim()}" to Runsheet`)
        }
        
        await showHideAdd(!showAdd)
    }
    
    useEffect(() => {
        actions.fetchTracts()
    }, [])
    
    return (
        <CustomModal className="max-w-[1200px] w-[1200px]"
            open={showAdd} modalHandler={() => showHideAdd(!showAdd)} center>
            <ModalHeader>Assign Tract{isRunsheetTab && ` to tab "${selectedTab.name}"`}</ModalHeader>
            <ModalBody>
                <div className="max-h-[500px] overflow-auto">
                    <table className="table table-sm table-sticky-headers table-zebra">
                        <thead>
                            <tr>
                                <th className="w-8"></th>
                                <th className="max-w-[320px] w-[320px]">Tract</th>
                                <th>Acreage</th>
                                <th>Assigned to</th>
                                <th>County</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {(tracts || [])
                                .map(tract => (
                                    <tr key={tract.id}>
                                        <td>
                                            <input
                                                type="radio"
                                                disabled={runsheetTabs.some(rt => rt.tractId === tract.id
                                                    && rt.id !== tabId)}
                                                className="radio radio-primary"
                                                value={tract.id}
                                                id={tract.id}
                                                name="tract"
                                                checked={selectedTractId === tract.id}
                                                onChange={() => setSelectedTractId(tract.id)} />
                                        </td>
                                        <td>
                                            <label className="text-left line-clamp-1 cursor-pointer" htmlFor={tract.id}>
                                                {tract.name}
                                            </label>
                                        </td>
                                        <td>{tract.grossAcreage}</td>
                                        <td>
                                            <div className="line-clamp-2 flex flex-col">
                                                {[
                                                    ...tract.runsheets.map(r => r.name),
                                                    ...tract.runsheetTabs.map(r => `${r.name} (Tab)`),
                                                ].map((name, idx) => <span key={idx}>{name}</span>)}
                                            </div>
                                        </td>
                                        <td>{tract.county?.name}</td>
                                        <td>
                                            <Link
                                                className="btn btn-secondary btn-xs"
                                                to={`/tract/${tract.id}/ownership`}>
                                                See Ownership
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-secondary" onClick={() => {
                    showHideAdd(!showAdd)
                    showCreateTract(true)
                }}>New Tract</button>
                <button
                    type="button"
                    className="btn btn-primary btn-outline"
                    onClick={() => {
                        showHideAdd(!showAdd)
                    }}>
                    Cancel
                </button>
                <button
                    type="submit"
                    className="mr-3 btn btn-primary"
                    onClick={assignTract}>
                    Assign
                </button>
            </ModalFooter>
        </CustomModal>
    )
}
